import { MISC_ALERT } from '../actions/misc'

const initialState = {
  loading: false,
  alert: {
    show: false,
    text: '',
    type: ''
  }
}

const miscReducer = (state = initialState, action) => {
  switch (action.type) {
    case MISC_ALERT:
      return {
        ...state,
        alert: action.alert
      }
    default:
      return state
  }
}

export default miscReducer
